// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"c5f07fe4","455":"8fcf2bb9","457":"ca88dcde","603":"c944488d","649":"4a2a2e4a","709":"98f50d56","802":"d644a068","807":"29354fce","819":"df2b341e","852":"f0087bda","917":"6bd541d6"}[chunkId] + ".js";
};